module.exports = __webpack_public_path__ + "static/media/55_000027.1ce1f5fe.jpg";